export function textMorph(count: number, dictionary: string[]): string {
  const value = Math.abs(count) % 100,
    num = value % 10

  if (value > 10 && value < 20) return dictionary[2]

  if (num > 1 && num < 5) return dictionary[1]

  if (num === 1) return dictionary[0]

  return dictionary[2]
}
